module.exports = __webpack_public_path__ + "img/zw.65a21dc1.png";